var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJumpBack = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122.35 103.09",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39,79.67a1.94,1.94,0,0,1-1.12-.36,1.9,1.9,0,0,1-.4-2.65L22.13,50.43A1.88,1.88,0,0,1,24.7,50L51.13,67.52A1.89,1.89,0,1,1,49,70.67L24.11,54.12,5.92,78.9A1.91,1.91,0,0,1,4.39,79.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8,100.59a49.1,49.1,0,0,1-49-49.05,1.89,1.89,0,1,1,3.78,0A45.27,45.27,0,1,0,70.8,6.28a1.89,1.89,0,0,1,0-3.78,49,49,0,1,1,0,98.09Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJumpBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/jump_back.6cc0c4c9.svg";
export { ForwardRef as ReactComponent };